import { labelsOrderProductionStage } from "../../../utils/normalizeProductionStages";
import { labelsOrderProductionStatus } from "../../../utils/normalizeProductionStatus";
import { IProductEntity } from "../products/products.interface"

export type TServiceOrderStatus = "PROCESSING" | "COMPLETED" | "DEAD"

// export type TProductionStatus = "INICIO" | "PRODUCAO" | 'FINALIZACAO' | 'BILLED'

// export enum OrderProductionStatusEnum  {
//     "INICIO" = "INICIO",
//     "PRODUCAO" = "PRODUCAO",
//     "FINALIZACAO" = "FINALIZACAO",
//     "BILLED" = "BILLED"
// }

export const optionsProductionStatus = Object.entries(labelsOrderProductionStatus).map(([value, label]) => ({ label, value }));
export const optionsProductionStage = Object.entries(labelsOrderProductionStage).filter(([value]) => !["DEAD", "BILLED"].includes(value)).map(([value, label]) => ({ label, value })); 
// .filter(([value]) => !["DEAD", "BILLED", "PROCESSING"].includes(value)) // Filtra as opções
// .map(([value, label]) => ({ label, value })); 



// export enum OrderProductionStatusEnum {
//     DEAD = "DEAD",
//     INITIAL = "INITIAL",
//     PROCESSING = "PROCESSING",
  
//     EMITTED_OS = "EMITTED_OS",
  
//     PREPRINT = "PREPRINT",
//     PRINT = "PRINT",
  
//     CUT_AND_VINCO_AUTO = "CUT_AND_VINCO_AUTO",
//     CUT_AND_VINCO_MANUAL = "CUT_AND_VINCO_MANUAL",
  
//     LAMINATION = "LAMINATION",
  
//     HIGHLIGHT = "HIGHLIGHT",
//     FEATURED = "FEATURED",
  
//     WATER_TO_FINISH = "WATER_TO_FINISH",
  
//     IN_MACHINE = "IN_MACHINE",
  
//     PRODUCED = "PRODUCED",
  
//     BILLED = "BILLED",
//   }
// export enum ServiceOrderStatusEnum {
//     STAND_BY = "STAND_BY",
//     PRODUCTION = "PRODUCTION",
//     HALF_FINISHED = "HALF_FINISHED",
//     FINISHED = "FINISHED",
//   }


export enum ServiceOrderStageEnum {
  DEAD = "DEAD",
  INITIAL = "INITIAL",
  PROCESSING = "PROCESSING",

  EMITTED_OS = "EMITTED_OS",

  PREPRINT = "PREPRINT",
  PRINT = "PRINT",

  CUT_AND_VINCO_AUTO = "CUT_AND_VINCO_AUTO",
  CUT_AND_VINCO_MANUAL = "CUT_AND_VINCO_MANUAL",

  LAMINATION = "LAMINATION",

  HIGHLIGHT = "HIGHLIGHT",
  FEATURED = "FEATURED",

  WATER_TO_FINISH = "WATER_TO_FINISH",

  IN_MACHINE = "IN_MACHINE",

  PRODUCED = "PRODUCED",

  AWAITING_INVOICING = "AWAITING_INVOICING", // Novo status para WAITING_BILLING
  WAITING_BILLING = "WAITING_BILLING", // DEPRECATED

  INVOICE_PROBLEM = "INVOICE_PROBLEM", // Alterar o nome BILLING_PROBLEM para "INVOICE_PROBLEM"
  BILLING_PROBLEM = "BILLING_PROBLEM", // DEPRECATED

  INVOICED = "INVOICED", // Alterar o nome BILLED para "INVOICES" que remeterá para "Faturado"
  BILLED = "BILLED", // DEPRECATED
}

export enum ServiceOrderPriorityEnum {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  NO_PRIORITY = "NO_PRIORITY",
}

export enum ServiceOrderDueDateStatusEnum {
  ON_TIME = "ON_TIME",
  DELAYED = "DELAYED",
  EXPIRED = "EXPIRED",
}

export enum ServiceOrderStatusEnum {
  ERROR = "ERROR",
  INITIAL = "INITIAL",
  PROCESSING = "PROCESSING",

  ON_GOING = "ON_GOING",
  PRODUCTION = "PRODUCTION",
  DELAYED = "DELAYED",
  PRODUCED = "PRODUCED",
  HALF_BILLED = "HALF_BILLED",
  BILLED = "BILLED",
}

export type TStoreType = "EMPO" | "PAPELLO"


export interface IServiceOrderEntity {
    id: string
    createdAt: string
    externalProductionId: string
    isActive: boolean
    cartela?: string
    startDate: string
    dueDate?: string
    newDueDate?: string;
    dueDateStatus: ServiceOrderDueDateStatusEnum
    priority: "SEM_PRIORIDADE"
    stages: ServiceOrderStageEnum[]
    status: ServiceOrderStatusEnum
    price: string
    productType?: string
    products: IServiceOrderProduct[]
}

export interface IServiceOrdersListResponse{
    hasNextPage: boolean;
    data: IServiceOrderEntity[];
    total: number;   
}

export interface IUpdateServiceOrdersPayload {
    productsIds: string[]
    status: ServiceOrderStatusEnum
    osId: string
}

export interface IServiceOrdersUpdateResponse{
    successProducts: IServiceOrderProduct[];
    errorProducts: IServiceOrderProduct[];
}

export interface IServiceOrderProduct {
    id: string
    createdAt: string
    hubProductId: string
    status: ServiceOrderStatusEnum
    hubVariantsIds?: string[]
    nsOrderId: string
    originalPrice: string
    finalPrice: string
    nsOrderProductId: string
    artLink?: string
    serviceOrderId: string
    orderRegisteredOnOmieId?: string
    product: IProductEntity
    variants?: string[]
    serviceOrder?: IServiceOrderEntity
    quantity: number
    orderQuantity?: number
    totalQuantity?: number
    artApprovedDate?: string;
    productionDueDate?: string
    newProductionDueDate?: string
    productionDueDateStatus?: string
    hcpCurrentFlow?: string | null
    hcpCurrentFlowStatusId?: string | null
    hcpCurrentFlowCode?: number | null
    hcpCurrentFlowStatusSequence?: number | null
    hcpCurrentFlowDisplayCode?: string | null
    hcpCurrentFlowStatusName?: string | null
    hcpCurrentFlowStartedAt?: string | null
    hcpCurrentFlowDeadline?: string | null
    hcpFinished?: boolean | null
    hcpPreServiceOrderId?: string | null
    productOrderCode?: string | null
    unitaryPrice?: string
}
